module.exports = __webpack_public_path__ + "static/media/pictornavbar.b1c9dc02.png";